import { Vars } from './../model/vars';
import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Observable } from 'rxjs/Observable';
import { catchError, map , tap} from 'rxjs/operators';
import { ExecutingUnit } from '../entities/executingUnit';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Hhelpdesk } from '../entities/hhelpdesk';
import { CostCenter } from '../entities/costCenter';
import { Employee } from '../entities/employee';
import { ReportCurrentEmployeeData } from '../entities/report-current-employee-data';
import { ProgrammaticStructure } from '../entities/programmaticStructure';
import { SnpDeduction } from '../entities/snp-deduction';
import { Afp } from '../entities/afp';
import { Bank } from '../entities/bank';
import { FiscalYear } from '../entities/fiscalYear';
import { EmployeeType } from '../entities/employeeType';
import * as FileSaver from 'file-saver';


interface ExtraSearchFields {
  object?: any;
  fiscalYear?: FiscalYear,
  executingUnit?: ExecutingUnit,
  employeeType?: EmployeeType,
  monthBirthDay?: Hhelpdesk,
  programmaticStructure?: ProgrammaticStructure,
  costCenter: CostCenter,
  costCenterDesignation: CostCenter,
  snpDeduction: SnpDeduction,
  jobtitle: Employee,
  afp: Afp,
  bank: Bank
}

@Injectable()
export class ReportCurrentEmployeeDataService extends BaseReportService<ReportCurrentEmployeeData> {

  public uri = '/api/reportCurrentEmployeeData/';

  constructor(injector: Injector) {
    super(injector);
    ////console.log('Instance ReportCurrentEmployeeDataService');
  }

  buildSentence(entity?: ReportCurrentEmployeeData, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.fiscalYear ?
          `fiscalYear.id${QueryOperator.Equal}${extraSearchFields.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.monthBirthDay ?
          `monthBirthDay.id${QueryOperator.Equal}${extraSearchFields.monthBirthDay.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.programmaticStructure ?
          `programmaticStructure${QueryOperator.Equal}${extraSearchFields.programmaticStructure.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.costCenter ?
          `costCenter.id${QueryOperator.Equal}${extraSearchFields.costCenter.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.costCenterDesignation ?
          `costCenterDesignation.id${QueryOperator.Equal}${extraSearchFields.costCenterDesignation.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.snpDeduction ?
          `snpDeduction.id${QueryOperator.Equal}${extraSearchFields.snpDeduction.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.jobtitle ?
          `jobtitle.id${QueryOperator.Equal}${extraSearchFields.jobtitle.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.afp ?
          `afp.id${QueryOperator.Equal}${extraSearchFields.afp.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.bank ?
          `bank.id${QueryOperator.Equal}${extraSearchFields.bank.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      ////console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  searchToReport(entity?: ReportCurrentEmployeeData, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<ReportCurrentEmployeeData>> {
     //console.log('searchToReport')
    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<ReportCurrentEmployeeData>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          }
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  searchToViewTable(   fiscalYear: any,
    executingUnit: any,
    employeeType: any,
    monthBirthday: any,
    programmaticStructure: any,
    costCenter: any,
    costCenterDesignation: any,
    snpDeduction: any,
    jobtitle: any,
    afp: any,
    bank: any,
    status:any,
    reportType:any,
    formatDate:any,
    object: Vars
    ): Observable<any> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('employeeTypeId', employeeType)
        .set('monthBirthday', monthBirthday)
        .set('programmaticStructureId', programmaticStructure)
        .set('costCenterId', costCenter)
        .set('costCenterDesignationId', costCenterDesignation)
        .set('jobTitleId', jobtitle)
        .set('snpDeductionId', snpDeduction)
        .set('afpId', afp)
        .set('bankId', bank)
        .set('status', status)
        .set('reportType', reportType)
        .set('formatDate', formatDate)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       );
  }

  downloadCSV(url: string, object: any, nameFile: string): Observable<Blob> {
  const ruta = this.rutaServidor + this.uri + url;

  if (object && object.lstEmployeeType) {
  object.lstEmployeeType = object.lstEmployeeType.filter(x => x != null);
  }

  
  this.spinnerService.showAll();

  return this.httpClient.post(ruta, object, { responseType: 'blob' })
  .pipe(
  map(res => {
  this.spinnerService.hideAll();
  const blob = new Blob([res], { type: 'text/csv;charset=utf-8' });
  FileSaver.saveAs(blob, nameFile);
  return blob;
  }),
  catchError(err => {
  this.spinnerService.hideAll();
  this.notificationService.serverErrorMessage(
  err.status + ' - Ocurrió un error. Por favor, inténtelo nuevamente más tarde.'
  );
  return new Observable<Blob>();
  })
  );
 }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-current-employee-data.service.ts